import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FetchDataService {

  // private weatherUrl = './assets/dummyData.json';
  // private weatherUrl = 'http://api.openweathermap.org/data/2.5/weather?q=kanpur&appid=e69456d7bebfbd74c8d9b761ed4ca18b'

  private weatherUrl = 'https://api.openweathermap.org/data/2.5/weather?q='

  constructor(private http:HttpClient) { }

  getweatherData(data):Promise<any>{
    console.log(data);
    console.log(this.weatherUrl + data + '&appid=e69456d7bebfbd74c8d9b761ed4ca18b')
    return this.http.get<any>(
      this.weatherUrl + data + '&appid=e69456d7bebfbd74c8d9b761ed4ca18b'
      // this.weatherUrl
    ).toPromise();
  }


}
